import React from 'react';

import Box from '@mui/material/Box';

import { KnzInlineProps } from '../../types';

/**
 * キーボードキー表示（`{{kbd:Ctrl+S}}`）。
 * `+` で区切って各キーを個別のキーキャップとして表示する。
 */
export const KbdInline: React.FC<KnzInlineProps> = ({ value }) => {
  const keys = value
    .split('+')
    .map((k) => k.trim())
    .filter(Boolean);
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
        // 段落先頭字下げ（textIndent）の影響を受けないよう打ち消す
        textIndent: 0,
        gap: 0.25,
      }}
    >
      {keys.map((k, i) => (
        <React.Fragment key={i}>
          {i > 0 && (
            <Box component="span" sx={{ color: 'text.disabled', fontSize: '0.75em' }}>
              +
            </Box>
          )}
          <Box
            component="kbd"
            sx={{
              display: 'inline-block',
              px: 0.75,
              py: 0.1,
              fontSize: '0.8em',
              fontFamily: 'monospace',
              lineHeight: 1.6,
              border: 1,
              borderColor: 'divider',
              borderBottomWidth: 2,
              borderRadius: 1,
              bgcolor: 'action.hover',
              color: 'text.primary',
            }}
          >
            {k}
          </Box>
        </React.Fragment>
      ))}
    </Box>
  );
};

export default KbdInline;
